import { render, staticRenderFns } from "./CategoryCount.vue?vue&type=template&id=00365299&scoped=true"
import script from "./CategoryCount.vue?vue&type=script&lang=js"
export * from "./CategoryCount.vue?vue&type=script&lang=js"
import style0 from "./CategoryCount.vue?vue&type=style&index=0&id=00365299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00365299",
  null
  
)

export default component.exports